import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import toast from 'react-hot-toast';
import styles from '../../styles/BookingModal.module.css';

interface PaymentSuccess {
    payment_intent_id: string;
    amount: number;
    status: string;
}

interface StripeCheckoutFormProps {
    onSuccess: (paymentDetails: PaymentSuccess) => Promise<void>;
}

const StripeCheckoutForm = ({ onSuccess }: StripeCheckoutFormProps) => {
    const stripe = useStripe();
    const elements = useElements();
    const [submitting, setSubmitting] = useState(false);
    const [ready, setReady] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        setSubmitting(true);
        const { error, paymentIntent } = await stripe.confirmPayment({ elements, redirect: 'if_required' });
        setSubmitting(false);
        if (error) {
            toast.error(`${error.code || 'payment_error'}: ${error.message || 'Payment failed'}`);
            return;
        }
        if (paymentIntent && (paymentIntent.status === 'succeeded' || paymentIntent.status === 'requires_capture')) {
            await onSuccess({ payment_intent_id: paymentIntent.id, amount: paymentIntent.amount || 0, status: paymentIntent.status });
            return;
        }
    };

    return (
        <form onSubmit={handleSubmit} className={styles.paypalContainer}>
            <PaymentElement onReady={() => setReady(true)} />
            {ready ? (
                <button type="submit" disabled={!stripe || submitting} className={`${styles.button} ${styles.primaryButton} mt-4`}>
                    {submitting ? 'Processing...' : 'Pay Now'}
                </button>
            ) : (
                <p className={styles.priceText}>Loading payment…</p>
            )}
        </form>
    );
};

export default StripeCheckoutForm;
